import { Component, OnInit } from '@angular/core';

declare var $: any

@Component({
  selector: 'app-team',
  templateUrl: './team.component.html',
  styleUrls: ['./team.component.scss']
})
export class TeamComponent implements OnInit {

  peoples = [
    {
      type: 'postdoc',
      title: 'Postdoc',
      sub_title: 'scholars',
      students: [
        {
          fullname: 'Jianxing Xiao',
          photo: 'jianxing_xiao.jpg',
          descs: [
            'Jianxing Xiao holds a Ph.D. in Agricultural Electrification and Automation from China Agricultural University, with a research focus on agricultural robotics, computer vision, and autonomous navigation. His work integrates multi-sensor fusion, machine vision, and intelligent control to develop robust robotic systems for complex agricultural environments. He has published research on agricultural machinery navigation, obstacle detection and avoidance, and animal recognition. He is currently working on VLA-based embodied intelligence navigation systems for agricultural machinery. '
            ]
          }
      ]
    },
    {
      type: 'phd',
      title: 'PhD',
      sub_title: 'student',
      students: [
        {
          fullname: 'Xintong Jiang',
          photo: 'Xintong Jiang.jpg',
          descs: [
            'Xintong Jiang earned her Master\'s in Bioresource Engineering and Bachelor\'s in Computer Science from McGill. Xintong is passionate about leveraging advanced machine vision algorithms and statistical models to address challenges in indoor and field settings. She is enthusiastic about exploring cutting-edge techniques and is always eager to take on new challenges.'
          ]
        },
        {
          fullname: 'Mohamed Debbagh',
          photo: 'mohamed_debbagh.jpg',
          descs: ['Mohamed Debbagh\'s research background is in sensor fusion and precision agriculture and is a technical co-founders of the company Circulus Agtech.  His current research focus is on the application of computer vision and Machine Learning techniques for plant health assessment to improve crop throughput in controlled environment agriculture, as well as GHG monitoring in agriculture.']
        },
        {
          fullname: 'Xuehai Zhou',
          photo: 'xuehai_zhou.jpg',
          descs: ['Xuehai Zhou has distinguished himself in the field of digital agriculture, holding a Master\'s degree in Bioresource Engineering from McGill University, Canada, and a Bachelor\'s degree in Computer Science from the University of Oregon, USA. Before pursuing his studies at McGill, Zhou contributed to the Baidu Big Data Lab in Beijing, China. His expertise in statistical analysis, computer vision, and deep learning technologies has been significant in advancing plant phenotyping.']
        },
        {
          fullname: 'Yu Tian',
          photo: 'yu_tian.jpg',
          descs: ['Yu Tian received her Bachelor\'s and Master\'s degrees in Software Engineering from Northwest University, China. Her research focuses on point cloud analysis and its applications in plant phenotyping. In particular, she investigates label-efficient deep learning techniques for extracting phenotypic traits from 3D plant scans.']
        },
        {
          fullname: 'Liuyi He',
          photo: 'liuyi_he.jpg',
          descs: ['Liuyi He pursued a Bachelor\'s degree in Geomatics Engineering from Shandong University of Science and Technology, China, and a Master\'s degree in Spatial Engineering from the University of Twente. She is eager to combine remote sensing techniques and deep learning to explore new challenges in smart agriculture development.']
        },
        {
          fullname: 'Weitong Wang',
          photo: 'weitong.jpg',
          descs: ['Weitong Wang earned his Master’s degree in Mechanical Engineering from the Hong Kong University of Science and Technology and his Bachelor’s degree in Mechanical Design, Manufacturing, and Automation from Sichuan University. His research focuses on optimizing tomato growth patterns and improving fruit productivity through high-throughput plant phenotyping and image analysis.']
        },
        {
          fullname: 'Arindam Sikdar',
          photo: 'arindam.jpeg',
          descs: ['Arindam is a botanist-turned-AI innovator. After an integrated BSc–MSc in Botany (Visva-Bharati, India) and an MSc in Biology (Memorial University) on lingonberry epigenomics, he founded Lingonverse to apply AI to lingonberry breeding worldwide. Now a PhD researcher, he builds deep-learning phenomics for early wheat disease detection from spikelets and yield prediction, equipping Quebec breeders with faster diagnostics to strengthen resilience and accelerate Canadian breeding programs.']
        },
        {
          fullname: 'Wang Mo',
          photo: 'WangMo.JPG',
          descs: ['I earned my Bachelor’s degree in Mathematics and Statistics from the University of Toronto and my Master’s degree in Mathematics from the University of British Columbia (UBC), where my research focused on sensitivity analysis and climate-driven uncertainty quantification in agricultural greenhouse gas emissions modeling. Building on this foundation in mathematical modeling and statistical analysis, I am now a Ph.D. student focusing on deep learning and computer vision, with the goal of combining rigorous quantitative methods and AI-driven approaches to address real-world challenges in smart agriculture.']
        },
      ]
    },
    // {
    //   type: 'visiting scholar',
    //   title: 'Visiting',
    //   sub_title: 'scholar',
    //   students: [
    //     // {
    //     //   fullname: 'He Li',
    //     //   photo: 'he_li.png',
    //     //   descs: ['He Li received her Bachelor\'s and Ph.D. degrees in Software Engineering and Computer Science and Technology from Yanshan University, China. After completing her doctorate, she joined the School of Information Science and Engineering at Yanshan University, where she is currently an Associate Professor. Her research interests include intelligent information processing, computer vision, and pattern recognition.']
    //     // },
    //     // {
    //     //   fullname: 'Weidong Yuan',
    //     //   photo: 'weidong.jpg',
    //     //   descs: ['Weidong Yuan earned his bachelor\'s degree from Nanjing Forestry University and is currently a fourth-year doctoral student at the same university. His research focuses on spectral and hyperspectral imaging data analysis techniques, as well as the design of agricultural and forestry machinery and equipment.']
    //     // },
    //   ]
    // },
    // {
    //   type: 'master',
    //   title: 'Master',
    //   sub_title: 'student',
    //   students: [
    //     {
    //       fullname: 'Nazia Hossain',
    //       photo: 'Nazia.jpg',
    //       descs: ['Nazia Hossain completed her B.Sc. in Electrical and Electronic Engineering at the Islamic University of Technology (IUT). Currently, she is pursuing a master\'s in Bioresource Engineering at McGill University. Her research focuses on advancing precision agriculture through Artificial Intelligence. She has witnessed firsthand the transformative impact of AI and is captivated by its potential to revolutionize industries and societies alike. This potential fuels her passion to contribute to AI, aiming to create a technologically advanced ecosystem that is ethically and morally beneficial for everyone.']
    //     },
    //     {
    //       fullname: 'Mason Jackson',
    //       photo: 'mason_jackson.jpg',
    //       descs: ['Mason holds a B.Sc. in Molecular Genetics from the University of Alberta and has gained extensive research experience across various institutions in Alberta, including the Government of Alberta Ministry of Agriculture, Natural Resources Canada, and Lakeland College. With a strong passion for agronomy, plant breeding, and pulse crops, Mason aims to enhance his expertise by integrating innovative techniques in crop breeding and drone imagery. His current project focuses on leveraging drone technology to improve the evaluation of breeding lines in the pulse breeding program at McGill University. ']
    //     },
    //   ]
    // },
    {
      type: 'undergraduates',
      title: 'Undergraduate',
      sub_title: 'student',
      students: [
        {
          fullname: 'Asahi Suzuki',
          photo: 'asahi_suzuki.jpg',
          descs: ['Asahi Suzuki is a U2 Bioresource Engineering student at McGill University. His interest focuses on the intersection of food production, automation, and robotics. His work experience includes research in large scale agriculture and internship at a robotics company developing autonomous harvesting systems for greenhouse production.']
        },
      ]
    },
    {
      type: 'alumnus',
      title: 'Alumnus',
      sub_title: '',
      students: [
        {
          fullname: 'Nazia Hossain',
          descs: [
            'Graduated with Master\'s degree in Bioresource Engineering, 2026.'
          ]
        },
        {
          fullname: 'Mason Jackson',
          descs: [
            'Graduated with Master\'s degree in Bioresource Engineering, 2026.'
          ]
        },
        {
          fullname: 'He Li',
          descs: [
            'Visiting scholar, 2025-2026, an associate professor at School of Information Science and Engineering at Yanshan University.'
          ]
        },
        {
          fullname: 'Weidong Yuan',
          descs: [
            'Visiting PhD student from Nanjing Forestry University, China, 2025.'
          ]
        },
        {
          fullname: 'Mana Eskandari',
          descs: ['Postdoctoral fellow, 2026.']
        },
        {
          fullname: 'Alice Liang',
          descs: ['Undergraduate student at McGill University, 2026.']
        },
        {
          fullname: 'Jiajun Zhu',
          descs: ['Undergraduate student at McGill University, 2026.']
        },
        {
          fullname: 'Libin Wu',
          descs: [
            'Visiting PhD student from Fujian Agriculture and Forestry University, China, 2025.'
          ]
        },
        {
          fullname: 'Rui Kang',
          descs: ['Visiting scholar, 2023–2024. Now an associate professor at Nanjing Agricultural University.']
        },
        {
          fullname: 'Weiqun Wang',
          descs: ['Visiting graduate student from the University of Bologna, Italy, 2024.']
        },
        {
          fullname: 'Zhouzhou Zheng',
          descs: ['Visiting Ph.D. student, 2023–2024.']
        },
        {
          fullname: 'Yixue Liu',
          descs: ['Visiting Ph.D. student, 2023–2024.']
        },
        {
          fullname: 'Liyi Luo',
          descs: ['Ph.D. student, 2022–2023. Now a research assistant at the Beijing Institute of Technology, Tsinghua University.']
        },
        {
          fullname: 'Yu Yang',
          descs: ['Visiting Ph.D. student, 2022–2023. Currently pursuing the Ph.D. degree at the School of Internet of Things Engineering, Jiangnan University.']
        },
        {
          fullname: 'Li Lu',
          descs: ['Undergraduate student at McGill University, 2023.']
        },
        {
          fullname: 'Félix Bédard',
          descs: ['Undergraduate student at McGill University, 2022.']
        },
        {
          fullname: 'Mandy Sun',
          descs: ['Undergraduate student at McGill University, 2022.']
        }        
      ]
    },
  ]

  // undergraduates = [
  //   "Alice Liang"
  // ]

  // alumnus = [
  //   "Weiqun Wang (Visiting graduate student, University of Bologna, Italy)",
  //   "Rui (Ray) Xu (Undergraduate student)",
  //   "Li Lu (Undergraduate student)",
  //   'Rui Kang (Visiting professor)',
  //   'Zhouzhou Zheng (Visiting PhD student)',
  //   'Liyi Luo (PhD student)',
  //   'Yu Yang (Visiting PhD student)',
  //   'Yixue Liu (Visiting PhD student)',
  //   'Félix Bédard (Undergraduate student)',
  //   'Mandy Sun (Undergraduate student)'
  // ]

  constructor() { }

  ngOnInit(): void {
    $('html, body').animate({ scrollTop: 0 }, 0);
  }

}
